import { render, staticRenderFns } from "./ProjectListItemComponent.vue?vue&type=template&id=8cf364bc&scoped=true&"
import script from "./ProjectListItemComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectListItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListItemComponent.vue?vue&type=style&index=0&id=8cf364bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf364bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VChip,VImg,VSpacer,VTooltip})
